import React from 'react'
import Icon from 'components/Icon'

import styles from './ArchivedItemIndicator.sass'

interface archivedItemsIndicatorProps {
  count: number
}

const ArchivedItemsIndicator = ({ count }: archivedItemsIndicatorProps) => (
  <div className={styles.bundleArchivedItemSection}>
    <Icon name="info" size={20} />
    <span> {count} items archived </span>
  </div>
)

export default ArchivedItemsIndicator
